import * as methods from '../methods';
import { Resource } from '../Resource';
import * as transformers from '../transformers';
const rootPath = 'horizons';
export const fromRaw = {
    get: (x) => x
};
const cacheConfig = {
    staleTime: 20 * 60 * 1000
};
const horizons = Resource((requesterBuilder) => {
    const getAll = () => requesterBuilder({
        path: rootPath,
        requestCtx: {
            method: 'GET',
            transform: transformers.paginatedResponse(fromRaw.get)
        }
    });
    return {
        get: methods.get({ rootPath, requesterBuilder, fromRaw: fromRaw.get }),
        getAll,
        getAllPage: methods.getAllPages({ getMany: getAll, cacheConfig })
    };
});
export default horizons;
